module.exports = __webpack_public_path__ + "static/media/Treatment_types.07a9a2c3.png";